export const districtDiagnosticIntroSteps = [
  {
    element: '#printButton',
    intro: 'Click here to print the WordFlight Diagnostic data for the selected Diagnostic page.'
  },
  {
    element: '.report',
    intro: 'The Diagnostic page is where you can view student Diagnostic data (Pre, Mid, and Post Diagnostic) for the school.'
  },
  {
    element: '.district-report-header-group',
    intro: 'Select (Automatic) Word Recognition or Decoding (Grades 5 and Up Only) to view the specific automatic word recognition or decoding data from the WordFlight Diagnostic.'
  },
  {
    element: '#district-report-diagnostic-progress',
    intro: 'Select which Diagnostics to compare from the Compare Tests dropdown. Then see which number of students and percentage of students moved and stayed in the same risk categories for the selected test comparison.'
  },
  {
    element: '#performanceChart',
    intro: 'See the number of students and percentage of students in each risk category for each Diagnostic assessment (Pre, Mid and Post).'
  },
  {
    element: '#makingGains',
    intro: 'See the percentage of students who showed an increase between the Diagnostic administrations.'
  },
  {
    element: '#improvement',
    intro: 'Select which Diagnostics to compare with the Compare Tests dropdown. See the number of students within each Scale Score Improvement category for the selected test comparison.'
  }
];